import React, { useState, useEffect, useMemo } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { viewState } from "../../Redux/Actions/settingsActions";

const EditState = () => {
  const { id } = useParams();
  const idMemo = useMemo(() => id, [id]); 

  const { stateData } = useSelector((state) => state.states);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [statePayload, setStatePayload] = useState({
    id: idMemo,
    name: "",
    country_name: "",
  });

  useEffect(() => {
    if (idMemo) {
      dispatch(viewState(idMemo));
    } else {
      console.warn("No State ID found in URL");
    }
  }, [dispatch, idMemo]);

  useEffect(() => {
    if (stateData?.data?.length > 0) {
      const stateItem = stateData.data[0];
      setStatePayload({
        id: stateItem._id,
        name: stateItem.state_name,
        country_name: stateItem.country?.country_name || "",
      });
    }
  }, [stateData]);

  return (
    <MainLayout>
      <div className="bg-white border-24 grid-span-5 padding-20" style={{ width: "100%" }}>
        <div className="flex-container flex-justify-between align-center">
          <h1>Edit State</h1>
          <button onClick={() => navigate(-1)} className="button-class">
            Go Back
          </button>
        </div>
        <form>
          <div className="flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="add-image">
                Country
              </span>
              <input
                className="input-class"
                type="text"
                name="country_name"
                disabled
                value={statePayload.country_name}
                placeholder="Country's Name..."
              />
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="subcategory-name">
                State Name
              </span>
              <input
                className="input-class"
                type="text"
                value={statePayload.name}
                onChange={(event) =>
                  setStatePayload((prevData) => ({
                    ...prevData,
                    name: event.target.value,
                  }))
                }
                placeholder="State's Name..."
              />
            </div>
          </div>
          <div className="span2 flex-end margin-h-10">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="button-class-white"
            >
              Cancel
            </button>
            <button className="button-class" style={{ marginTop: "10px" }}>
              Save
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default EditState;
